// extracted by mini-css-extract-plugin
module.exports = {"container":"GameDetailsNew_container_2Wgp5","iteration":"GameDetailsNew_iteration_1pZTa"};